'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OneToOne = exports.ManyToMany = exports.ForeignKey = exports.Attribute = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.attr = attr;
exports.fk = fk;
exports.many = many;
exports.oneToOne = oneToOne;

var _findKey = require('lodash/findKey');

var _findKey2 = _interopRequireDefault(_findKey);

var _descriptors = require('./descriptors');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Attribute = exports.Attribute = function () {
    function Attribute(opts) {
        (0, _classCallCheck3.default)(this, Attribute);

        this.opts = opts || {};

        if (this.opts.hasOwnProperty('getDefault')) {
            this.getDefault = this.opts.getDefault;
        }
    }

    Attribute.prototype.install = function install(model, fieldName, orm) {
        (0, _defineProperty2.default)(model.prototype, fieldName, (0, _descriptors.attrDescriptor)(fieldName));
    };

    return Attribute;
}();

var RelationalField = function () {
    function RelationalField() {
        (0, _classCallCheck3.default)(this, RelationalField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        if (args.length === 1 && (0, _typeof3.default)(args[0]) === 'object') {
            var opts = args[0];
            this.toModelName = opts.to;
            this.relatedName = opts.relatedName;
            this.through = opts.through;
            this.throughFields = opts.throughFields;
        } else {
            this.toModelName = args[0];
            this.relatedName = args[1];
        }
    }

    RelationalField.prototype.getClass = function getClass() {
        return this.constructor;
    };

    return RelationalField;
}();

var ForeignKey = exports.ForeignKey = function (_RelationalField) {
    (0, _inherits3.default)(ForeignKey, _RelationalField);

    function ForeignKey() {
        (0, _classCallCheck3.default)(this, ForeignKey);
        return (0, _possibleConstructorReturn3.default)(this, _RelationalField.apply(this, arguments));
    }

    ForeignKey.prototype.install = function install(model, fieldName, orm) {
        var toModelName = this.toModelName;

        var toModel = toModelName === 'this' ? model : orm.get(toModelName);

        (0, _defineProperty2.default)(model.prototype, fieldName, (0, _descriptors.forwardManyToOneDescriptor)(fieldName, toModel.modelName));

        var backwardsFieldName = this.relatedName ? this.relatedName : (0, _utils.reverseFieldName)(model.modelName);

        var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

        if (backwardsDescriptor) {
            var errorMsg = (0, _utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
            throw new Error(errorMsg);
        }

        (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, _descriptors.backwardManyToOneDescriptor)(fieldName, model.modelName));

        var ThisField = this.getClass();
        toModel.virtualFields[backwardsFieldName] = new ThisField(model.modelName, fieldName);
    };

    return ForeignKey;
}(RelationalField);

var ManyToMany = exports.ManyToMany = function (_RelationalField2) {
    (0, _inherits3.default)(ManyToMany, _RelationalField2);

    function ManyToMany() {
        (0, _classCallCheck3.default)(this, ManyToMany);
        return (0, _possibleConstructorReturn3.default)(this, _RelationalField2.apply(this, arguments));
    }

    ManyToMany.prototype.install = function install(model, fieldName, orm) {
        var toModelName = this.toModelName;

        var toModel = toModelName === 'this' ? model : orm.get(toModelName);

        var throughModelName = this.through || (0, _utils.m2mName)(model.modelName, fieldName);

        var throughModel = orm.get(throughModelName);

        var throughFields = void 0;
        if (!this.throughFields) {
            var toFieldName = (0, _findKey2.default)(throughModel.fields, function (field) {
                return field instanceof ForeignKey && field.toModelName === toModel.modelName;
            });
            var fromFieldName = (0, _findKey2.default)(throughModel.fields, function (field) {
                return field instanceof ForeignKey && field.toModelName === model.modelName;
            });
            throughFields = {
                to: toFieldName,
                from: fromFieldName
            };
        } else {
            var _throughFields = (0, _slicedToArray3.default)(this.throughFields, 2),
                fieldAName = _throughFields[0],
                fieldBName = _throughFields[1];

            var fieldA = throughModel.fields[fieldAName];
            if (fieldA.toModelName === toModel.modelName) {
                throughFields = {
                    to: fieldAName,
                    from: fieldBName
                };
            } else {
                throughFields = {
                    to: fieldBName,
                    from: fieldAName
                };
            }
        }

        (0, _defineProperty2.default)(model.prototype, fieldName, (0, _descriptors.manyToManyDescriptor)(model.modelName, toModel.modelName, throughModelName, throughFields, false));

        model.virtualFields[fieldName] = new ManyToMany({
            to: toModel.modelName,
            relatedName: fieldName,
            through: this.through,
            throughFields: throughFields
        });

        var backwardsFieldName = this.relatedName ? this.relatedName : (0, _utils.reverseFieldName)(model.modelName);

        var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

        if (backwardsDescriptor) {
            var errorMsg = (0, _utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
            throw new Error(errorMsg);
        }

        (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, _descriptors.manyToManyDescriptor)(model.modelName, toModel.modelName, throughModelName, throughFields, true));
        toModel.virtualFields[backwardsFieldName] = new ManyToMany({
            to: model.modelName,
            relatedName: fieldName,
            through: throughModelName,
            throughFields: throughFields
        });
    };

    ManyToMany.prototype.getDefault = function getDefault() {
        return [];
    };

    return ManyToMany;
}(RelationalField);

var OneToOne = exports.OneToOne = function (_RelationalField3) {
    (0, _inherits3.default)(OneToOne, _RelationalField3);

    function OneToOne() {
        (0, _classCallCheck3.default)(this, OneToOne);
        return (0, _possibleConstructorReturn3.default)(this, _RelationalField3.apply(this, arguments));
    }

    OneToOne.prototype.install = function install(model, fieldName, orm) {
        var toModelName = this.toModelName;

        var toModel = toModelName === 'this' ? model : orm.get(toModelName);

        (0, _defineProperty2.default)(model.prototype, fieldName, (0, _descriptors.forwardOneToOneDescriptor)(fieldName, toModel.modelName));

        var backwardsFieldName = this.relatedName ? this.relatedName : model.modelName.toLowerCase();

        var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

        if (backwardsDescriptor) {
            var errorMsg = (0, _utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
            throw new Error(errorMsg);
        }

        (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, _descriptors.backwardOneToOneDescriptor)(fieldName, model.modelName));
        toModel.virtualFields[backwardsFieldName] = new OneToOne(model.modelName, fieldName);
    };

    return OneToOne;
}(RelationalField);

function attr(opts) {
    return new Attribute(opts);
}

function fk() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return new (Function.prototype.bind.apply(ForeignKey, [null].concat(args)))();
}

function many() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    }

    return new (Function.prototype.bind.apply(ManyToMany, [null].concat(args)))();
}

function oneToOne() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
    }

    return new (Function.prototype.bind.apply(OneToOne, [null].concat(args)))();
}